// import { useResolverForm } from '@hooks';
import { ResourceType } from '@constants';
import { useChangeAvatar, useUser } from '@hooks';
import { isEmpty } from 'lodash';
import React, { memo, useCallback, useMemo } from 'react';
import { KInput } from 'uikit';

const Avatar = () => {
  const { account } = useUser();

  const { mutate } = useChangeAvatar();

  const avatar = useMemo(() => account?.avatar ?? '', [account?.avatar]);

  const onChangeAvatar = useCallback(
    (e: any) => {
      if (e.target.files && !isEmpty(e.target.files)) {
        const v = e.target.files[0];
        const formData = new FormData();
        formData.append('file', v);
        formData.append('resourceType', ResourceType.Avatar);
        mutate(formData);
      }
    },
    [mutate]
  );

  return (
    <KInput.Avatar
      avatar={{
        size: '2xlg',
        source: avatar,
        alignItems: 'center',
        dp: 'flex',
        marginB: '1.25rem'
      }}
      onChange={onChangeAvatar}
    />
  );
};

export default memo(Avatar);
